export default {
  common: {
    login: 'Sign In',
    search: 'Search',
    please: 'Please enter',
    noMore: 'No more content',
    loading: 'Loading'
  },
  validation: {
    emailRequired: 'Please enter your email',
    passwordRequired: 'Please enter your password',
    captchaRequired: 'Please enter the verification code',
    emailFormat: 'Please enter a valid email address',
    confirmPasswordRequired: 'Please re-enter your password',
    nicknamePlaceholder: 'Nickname',
    nicknameRequired: 'Please set your nickname',
    avatarTip: 'Avatar',
    avatarRequired: 'Please upload your avatar'
  },
  login: {
    emailPlaceholder: 'Enter your emai',
    passwordPlaceholder: 'Enter your password',
    captchaPlaceholder: 'Enter verification code',
    forgot: 'Forgot password?',
    goRegister: 'Register now',
    logout: 'Log out'
  },
  register: {
    title: 'Register',
    emailPlaceholder: 'Enter email',
    codePlaceholder: 'Enter code',
    getCode: 'Get code',
    passwordPlaceholder: 'Enter password',
    confirmPlaceholder: 'Confirm password',
    nicknamePlaceholder: 'Set nickname',
    setAvatar: 'Set avatar',
    submit: 'Register',
    uploading: 'Uploading...'
  },
  forgot: {
    title: 'Reset Password',
    emailPlaceholder: 'Enter email',
    codePlaceholder: 'Enter code',
    getCode: 'Get code',
    passwordPlaceholder: 'Enter password',
    confirmPlaceholder: 'Confirm password',
    submit: 'Confirm',
    noMatch: 'The two passwords do not match'
  },
  contact: {
    title: 'Welcome to contact us',
    infoTitle: 'Contact Us',
    namePlaceholder: 'Your Name',
    nameRequired: 'Please enter your name',
    emailPlaceholder: 'Your Email',
    companyPlaceholder: 'Company Name',
    phonePlaceholder: 'Your Phone',
    contentPlaceholder: 'Message',
    contentRequired: '',
    captchaPlaceholder: 'Enter verification code',
    submit: 'Send Message',
    submitSuccess: 'Message sent successfully'
  },
  mine: {
    myLikes: 'My Likes'
  }
}
